import React from "react";
import Textlistitem from "./textlistitem";
import classes from './text.module.css';

const TxtList = ({items,title}) => {
    return(
        <div className={classes.contBlock}>
            <h2>{title}</h2>
            {items.map((item, index) => 
                <Textlistitem number={index +1} item={item} key={item.id} />
            )}
        </div>
    )
}

export default TxtList;